module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chimage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pvii.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 1")]), _vm._v(" Renewed Passion and Intense Pain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap02"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 2")]), _vm._v(" Dr. Wise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 3")]), _vm._v(" What a Difference a Doctor Makes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Hospital Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 5")]), _vm._v(" Rehab: The Key to the Speed and Quality of Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 6")]), _vm._v(" Setting a Realistic and Safe Goal after Hip Replacement Surgery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 7")]), _vm._v(" Tom Watson Gave Me Hope and Inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 8")]), _vm._v(" If Bo Jackson Can Run the Bases, Can I Run Down the Dance Floor in High Heels?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 9")]), _vm._v(" Rudy Galindo Skates with Two New Hips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 10")]), _vm._v(" Wayne Sleep’s New Hip Gets Him Back to the Royal Ballet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 11")]), _vm._v(" Time to Get Serious")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 12")]), _vm._v(" Back in the Ball Gown Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 13")]), _vm._v(" Kicking It All Up a Notch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 14")]), _vm._v(" Age Is Just a Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 15")]), _vm._v(" What Is the One Thing You Should Never Say to a Dancer?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 16")]), _vm._v(" Dance Training Offers Life Lessons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 17")]), _vm._v(" What Makes or Breaks a Winning Performance?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 18")]), _vm._v(" Sports Psychology and Dancing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 19")]), _vm._v(" The Spiritual Influence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 20")]), _vm._v(" What Makes a Winner?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 21")]), _vm._v(" Destiny at Disney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 22")]), _vm._v(" One Moment in Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About The Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 75
// module chunks = 0